import PropTypes from 'prop-types';
import CurrencyProp from '../../sections/profile/propTypes/currencyProp';

const propType = {
  code: PropTypes.string.isRequired,
  networkCode: PropTypes.string.isRequired,
  networkName: PropTypes.string.isRequired,
  currencyInfo: PropTypes.shape(CurrencyProp.propType).isRequired,
};

export default { propType };
